import React from "react";
import QueryString from "query-string";
import AppState from "./model/AppState";
import ObaTextField from "./components/ObaTextField";
import LogUtil from "./util/LogUtil";
import { FormControl, Snackbar } from "@material-ui/core";
import NavegadorUtil from "./util/NavegadorUtil";
import AlertaModel from "./model/AlertaModel";
import Carregando from "./components/Carregando";
import { ReactComponent as ImagemMenuBack } from "./assets/images/icons/menu-back.svg";
import Rodape from "./components/Rodape";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { Md5 } from "ts-md5";
import C5UsuarioDAO from "./dataAccess/C5/C5UsuarioDAO";

interface IAlterarSenhaProps extends RouteComponentProps {}

type AlterarSenhaState = {
  email: string;
  senha: string;
  confirmacaoSenha: string;
  token: string;
  carregando: boolean;
  concluido: boolean;
};

class AlterarSenha extends React.Component<IAlterarSenhaProps, AlterarSenhaState> {
  constructor(props: IAlterarSenhaProps) {
    super(props);

    this.alterar = this.alterar.bind(this);
    this.validaDados = this.validaDados.bind(this);

    this.state = {
      email: "",
      senha: "",
      confirmacaoSenha: "",
      token: "",
      carregando: false,
      concluido: true,
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Alterar minha senha");

    let query: any;
    query = QueryString.parse(this.props.location.search);

    if (query.email && query.hash) {
      this.setState({ email: query.email });

      const hash = Md5.hashStr(JSON.stringify({ email: query.email }));

      if (hash !== query.hash) {
        NavegadorUtil.alerta(this, "Erro ao acessar a tela de alteração de senha.  Favor acessar pelo link recebido por e-mail.");
        this.props.history.push('/esqueci-minha-senha');
      }

    } else {
      NavegadorUtil.alerta(this, "Erro ao acessar a tela de alteração de senha.  Favor acessar pelo link recebido por e-mail.");
      this.props.history.push('/esqueci-minha-senha');
    }
  }

  validaDados() {
    const {senha, confirmacaoSenha} = this.state;
    
    if (senha.length === 0) {
      NavegadorUtil.alerta(this, "Preencha o campo senha");
      return false;
    }

    if (confirmacaoSenha.length === 0) {
      NavegadorUtil.alerta(this, "Preencha o campo Confirmação de senha");
      return false;
    }

    if (senha !== confirmacaoSenha) {
      NavegadorUtil.alerta(
        this,
        "Senha e confirmação de senha não coincidem."
      );
      return false;
    }

    if (senha.length < 8) {
      NavegadorUtil.alerta(this, "A senha deve ter no mínimo 8 caracteres.");
      return false;
    }

    if (!/[A-Z]/.test(senha)) {
      NavegadorUtil.alerta(
        this,
        "A senha deve ter no mínimo um caractere maiúsculo."
      );
      return false;
    }

    if (!/[a-z]/.test(senha)) {
      NavegadorUtil.alerta(
        this,
        "A senha deve ter no mínimo um caractere minúsculo."
      );
      return false;
    }

    if (!/\d/.test(senha)) {
      NavegadorUtil.alerta(this, "A senha deve ter no mínimo um número.");
      return false;
    }
    return true;
  }

  alterar(): void {
    const { email, senha } = this.state;
    this.setState({ carregando: true });

    if (this.validaDados()) {
      C5UsuarioDAO.getInstance()
      .alterarSenha(email, senha)
      .then((r: any) => {
        this.setState({ carregando: false });
        NavegadorUtil.alerta(this, "Senha alterada com sucesso.  Experimente sua senha nova agora mesmo!");
        this.props.history.push('/login');
      })
      .catch(async (ex) => {
        NavegadorUtil.alerta(
          this,
          `Erro ao alterar senha do usuário [${ex.response.data.Message}].`
        );
        this.setState({ carregando: false });
      });
    } else {
      this.setState({ carregando: false });
    }
  }

  render(): any {
    const { senha, confirmacaoSenha, carregando, concluido } = this.state;
    const fieldWidth: number = 300;
    const objStyle: any = {
      width: fieldWidth,
      margin: "0 auto",
      display: "block",
      marginTop: 20,
    };
    let alerta: any = AppState.getAlerta();

    if (!alerta) {
      alerta = {
        exibirModal: false,
      } as AlertaModel;
    }

    return (
      <section className="login">
        <div
          className="header"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/img_login.png)`,
          }}
        >
          <div className="back" onClick={() => this.props.history.goBack()}>
            <ImagemMenuBack />
          </div>
        </div>
        <h1>Alterar minha senha</h1>
        <div className="regras-senha">
          Sua nova senha precisa ter: <br />
          <ul>
            <li>- Pelo menos 8 caracteres;</li>
            <li>- Letra maiúscula e minúscula;</li>
            <li>- Pelo menos um número;</li>
          </ul>
        </div>
        <FormControl variant="outlined" style={objStyle}>
          <ObaTextField
            onChange={(e) => this.setState({ senha: e.target.value as string })}
            type="password"
            style={{ width: fieldWidth }}
            variant="outlined"
            label="Nova senha"
            value={senha}
          />
        </FormControl>
        <FormControl variant="outlined" style={objStyle}>
          <ObaTextField
            onChange={(e) => this.setState({ confirmacaoSenha: e.target.value as string })}
            type="password"
            style={{ width: fieldWidth }}
            variant="outlined"
            label="Confirmação da nova senha"
            value={confirmacaoSenha}
          />
        </FormControl>
        <button onClick={this.alterar}>Alterar minha senha</button>
        <div className="subActions">
          <Link
            to={NavegadorUtil.getUrl("/login")}
            style={{ textAlign: "center", display: "block" }}
          >
            Voltar para o login
          </Link>
        </div>
        <Carregando exibir={carregando} concluido={concluido} />
        <Rodape parent={this} ativo="Menu"></Rodape>
        <Snackbar
          open={alerta.exibirModal}
          className="info"
          transitionDuration={1000}
          onClose={() => AppState.fecharAlerta(this)}
          autoHideDuration={6000}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{alerta.mensagem}</span>}
        />
      </section>
    );
  }
}

export default withRouter(AlterarSenha);
